<template>
  <div>
    <el-dialog top="2vh" title="Colunas" :visible.sync="dialog.columns" width="30%">
      <ul class="list-group">
        <li class="list-group-item" v-for="column of current" :key="column">{{ column }}</li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialog.columns = false">OK</el-button>
      </span>
    </el-dialog>

    <div class="mapping-config">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="5" v-if="userType !== '5'">
          <label class="mapping-label">{{ userType === '1' || userType === '3' ? $t('cliente') : $t('filial') }}</label>
          <CustomerList v-model="customerList" v-bind:customerType="userType === '2' ? 3 : 0" ref="customer" />
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="5">
          <label class="mapping-label">{{ $t('departamento') }}</label>
          <DepartmentList
            v-model="options.DEPARTAMENTO"
            :current="options.DEPARTAMENTO"
            :customer="customerList"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="5" v-if="!xml">
          <label class="mapping-label">{{ $t('meus-layouts') }}</label>
          <el-select v-model="layout" placeholder="Selecione uma opção" clearable>
            <el-option v-for="layout in list" :key="layout.id" :label="layout.name" :value="layout.id">
              <span style="float: left">{{ layout.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px"
                >({{ layout.fields.split(",").length }} colunas)</span
              >
            </el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="9" :xl="9" v-if="!xml && layout" class="mapping-layout-actions">
          <el-button type="info" @click="open">Ver colunas</el-button>
          <el-button type="success" @click="apply">Aplicar</el-button>
          <el-button @click="remove">Remover esse layout</el-button>
        </el-col>

        <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="5" v-if="xml">
          <label class="mapping-label">Serviço</label>
          <el-select
            v-model="options.servico"
            placeholder="Selecione o serviço"
            :disabled="availableServices.length === 0"
            filterable
          >
            <el-option
              v-for="srv in availableServices"
              :key="srv.code"
              :label="srv.name"
              :value="srv.code"
            />
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="9" :xl="9" v-if="xml">
          <label class="mapping-label">Adicionais</label>
          <div class="mapping-additionals">
            <el-checkbox v-model="options.vd" true-label="SIM" false-label="NÃO" title="Valor Declarado">Valor Declarado</el-checkbox>
            <el-checkbox v-model="options.ar" true-label="SIM" false-label="NÃO" title="Aviso de Recebimento">A.R.</el-checkbox>
            <el-checkbox v-model="options.arDigital" true-label="SIM" false-label="NÃO" title="A.R. Digital">AR Eletrônico</el-checkbox>
            <el-checkbox v-model="options.maoPropria" true-label="SIM" false-label="NÃO" title="Mão Própria">M.P.</el-checkbox>
            <el-checkbox v-model="options.artigosPerigosos" true-label="SIM" false-label="NÃO" title="Artigos Perigosos">A.P.</el-checkbox>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="mapping-section" v-if="!xml">
      <span class="mapping-section-title">Mapeamento das colunas ({{ data.length }})</span>
      <table class="table">
        <thead>
          <th class="w-33">Colunas</th>
          <th class="w-33">Valor Planilha</th>
          <th class="w-33">Campo</th>
        </thead>
        <tbody>
          <tr v-for="(item, index) of data" :key="index">
            <td>
              <el-tag type="primary">{{ item.column }}</el-tag
              >&nbsp;
              <el-checkbox v-model="item.ignore">Ignorar essa coluna</el-checkbox>
            </td>
            <td>
              <el-tag type="info">{{ item.value }}</el-tag>
            </td>
            <td>
              <el-select v-model="item.field" :disabled="item.ignore" filterable placeholder="Select">
                <el-option v-for="row in tableData" :key="row.key" :label="row.label" :value="row.key">
                  <span style="float: left">{{ row.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 11px">{{ row.description }}</span>
                </el-option>
              </el-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Tabela de Notas Fiscais (quando vier de XML) -->
    <span class="mapping-section-title mapping-section" v-if="xml && fileData && fileData.length"
      >Notas fiscais identificadas ({{ fileData.length }})</span
    >
    <el-table
      v-if="xml && fileData && fileData.length"
      :data="fileData"
      border
      class="mapping-nowrap"
      style="width: 100%"
    >
      <el-table-column prop="NUMERO" label="Número da Nota" width="120" />
      <el-table-column prop="SERIE" label="Série" width="80" />

      <el-table-column label="Valor Total" width="120">
        <template slot-scope="scope">
          R$ {{ parseFloat(scope.row.VALOR_TOTAL || 0).toFixed(2) }}
        </template>
      </el-table-column>

      <el-table-column label="Nome do Destinatário" min-width="250">
        <template slot-scope="scope">
          {{ (scope.row.ROW_RAW && scope.row.ROW_RAW.recipient && scope.row.ROW_RAW.recipient.name) || scope.row.NOME_DESTINATARIO }}
        </template>
      </el-table-column>

      <el-table-column label="Endereço Dest." min-width="250">
        <template slot-scope="scope">
          {{ scope.row.ROW_RAW && scope.row.ROW_RAW.recipient ? scope.row.ROW_RAW.recipient.address : '' }}
          <span v-if="scope.row.ROW_RAW && scope.row.ROW_RAW.recipient && scope.row.ROW_RAW.recipient.number">
            , {{ scope.row.ROW_RAW.recipient.number }}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="CEP Dest." width="120">
        <template slot-scope="scope">
          {{ scope.row.ROW_RAW && scope.row.ROW_RAW.recipient && scope.row.ROW_RAW.recipient.cep ? scope.row.ROW_RAW.recipient.cep : '-' }}
        </template>
      </el-table-column>

      <el-table-column label="Bairro Dest." width="180">
        <template slot-scope="scope">
          {{ scope.row.ROW_RAW && scope.row.ROW_RAW.recipient && scope.row.ROW_RAW.recipient.neighborhood ? scope.row.ROW_RAW.recipient.neighborhood : '-' }}
        </template>
      </el-table-column>

      <el-table-column label="Cidade Dest." width="180">
        <template slot-scope="scope">
          {{ scope.row.ROW_RAW && scope.row.ROW_RAW.recipient && scope.row.ROW_RAW.recipient.city ? scope.row.ROW_RAW.recipient.city : '-' }}
        </template>
      </el-table-column>

      <el-table-column label="UF Dest." width="80">
        <template slot-scope="scope">
          {{ scope.row.ROW_RAW && scope.row.ROW_RAW.recipient && scope.row.ROW_RAW.recipient.uf ? scope.row.ROW_RAW.recipient.uf : '-' }}
        </template>
      </el-table-column>
    </el-table>
    <div class="mapping-footer">
      <el-button @click="back()">Voltar</el-button>
      <el-button v-if="!xml" type="info" @click="save()">Salvar esse layout</el-button>
      <el-button type="primary" @click="validate()">Validar</el-button>
    </div>
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { LayoutService } from "@/services/customers/layout.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import DepartmentList from "@/xpost/views/register/department/DepartmentList";
import { UploadService } from "../../../../../services/customers/upload.services";
import ServicesList from "@/xpost/views/register/services/ServicesList";
import { CustomerService } from "@/services/customers/customers.services";


export default {
  name: "MappingColumn",
  props: ["fileData", "columnData", "customer", "userType", "xml", "detectNFe"],
  components: {
    CustomerList,
    DepartmentList,
    ServicesList,
  },
  mounted() {
    const vm = this;
    LayoutService.list().then((response) => {
      vm.list = response.records;
    });
    vm.customerList = vm.customer;
    vm.tableData = vm.tableData.sort((a, b) => a.label.localeCompare(b.label));
    if (vm.columnData.length === 0) {
      if (vm.fileData.length === 0) return false;
      const fields = Object.keys(vm.fileData[0]);
      for (let i = 0; i < fields.length; i++) {
        const f = vm.tableData.find((x) => vm.normalizeKey(x.key) === vm.normalizeKey(fields[i]));
        vm.data.push({
          index: i,
          column: `Coluna ${vm.generate(i).toUpperCase()}`,
          value: vm.fileData[0][fields[i]],
          field: f ? f.key : "",
          ignore: false,
        });
      }
    } else {
      vm.data = vm.columnData;
    }
  },
  methods: {
    normalizeKey(value) {
      return String(value || "")
        .replace(/^\uFEFF/, "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toUpperCase();
    },
    next() {
      const vm = this;
      vm.$emit("next");
    },
    back() {
      const vm = this;
      vm.$emit("back");
    },
    generate(a) {
      var b = [a],
        sp,
        out,
        i,
        div;
      sp = 0;
      while (sp < b.length) {
        if (b[sp] > 25) {
          div = Math.floor(b[sp] / 26);
          b[sp + 1] = div - 1;
          b[sp] %= 26;
        }
        sp += 1;
      }

      out = "";
      for (i = 0; i < b.length; i += 1) {
        out = String.fromCharCode("a".charCodeAt(0) + b[i]) + out;
      }

      return out;
    },
    validate() {
      const vm = this;

      const isNfe = Array.isArray(vm.fileData) && vm.fileData.length > 0 && vm.fileData[0].ROW_RAW;

      if (vm.xml && vm.userType !== "2" && vm.userType !== "5" && !vm.customerList) {
        return this.$message({
          type: "error",
          message: `É obrigatório selecionar um cliente!`,
          duration: 6000,
        });
      }

      if (vm.xml && isNfe) {
        vm.$emit("xml", vm.customerList, vm.options, vm.availableServices);
        vm.$emit("next");
      } else if (vm.xml) {
        const loading = vm.$loading(vm.$options.loading);
        UploadService.xml(vm.customerList, vm.xml)
          .then((response) => {
            vm.$emit("xml", vm.customerList, vm.options, vm.availableServices);
            vm.$emit("next");
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      } else {
        const f = vm.data.filter((x) => x.field === "");
        if (f.length > 0) {
          const x = f.filter((x) => x.ignore === false);
          if (x.length > 0) {
            const t = x.reduce(function (a, b) {
              return (a.column || a) + ", " + b.column;
            });
            return this.$message({
              type: "error",
              message: `Você precisa definir um campo ou ignorar as colunas (${t})!`,
              duration: 6000,
            });
          }
        }
        const duplicate = vm.data.filter((y) => {
          return vm.data.find((x) => x.field === y.field && x.index !== y.index);
        });
        if (duplicate.length > 0) {
          const x = duplicate.filter((x) => x.ignore === false);
          if (x.length > 1) {
            const t = x.reduce(function (a, b) {
              return (a.column || a) + ", " + b.column;
            });
            return this.$message({
              type: "error",
              message: `Existem as colunas (${t}) que possuem o mesmo campo mapeado. Deve possuir apenas um campo por coluna!`,
              duration: 6000,
            });
          }
        }
        const mandatory = vm.mandatory.filter((y) => {
          return !vm.data.find((x) => x.field === y);
        });
        if (mandatory.length > 0) {
          return this.$message({
            type: "error",
            message: `Os campos (${mandatory.join(
              ", "
            )}) são obrigatórios, por favor selecionar a coluna correspondente para esse campo!`,
            duration: 6000,
          });
        }
        if (vm.userType !== "2" && vm.userType !== "5" && !vm.customerList) {
          return this.$message({
            type: "error",
            message: `É obrigatório selecionar um cliente!`,
            duration: 6000,
          });
        }
        const newFileData = [];
        for (let i = 0; i < vm.fileData.length; i++) {
          const record = vm.fileData[i];
          const keys = Object.keys(record);
          const newRecord = {};

          for (let x = 0; x < vm.data.length; x++) {
            const row = vm.data[x];
            if (row.ignore) continue;
            newRecord[row.field] = record[keys[x]];
          }

          if (!newRecord.DEPARTAMENTO && vm.options.DEPARTAMENTO) {
            newRecord.DEPARTAMENTO = vm.options.DEPARTAMENTO;
          }

          if (this.detectNFe) {
            newRecord.options = { ...vm.options };
          }
          newFileData.push(newRecord);
      }
        if (this.detectNFe) {
          vm.$emit("validate", vm.data, vm.customerList, newFileData, vm.options);
        } else {
          vm.$emit("validate", vm.data, vm.customerList, newFileData);
        }
        vm.$emit("next");
      }
    },
    open() {
      const vm = this;
      const layout = vm.list.find((x) => x.id === vm.layout);
      if (layout) {
        vm.current = layout.fields.split(",");
        vm.dialog.columns = true;
      }
    },
    apply() {
      const vm = this;
      const layout = vm.list.find((x) => x.id === vm.layout);
      if (layout) {
        const f = layout.fields.split(",");
        for (let i = 0; i < vm.data.length; i++) {
          if (f[i]) {
            if (f[i].indexOf("ESPACO") !== -1) {
              vm.data[i].field = null;
              vm.data[i].ignore = true;
            } else {
              vm.data[i].ignore = false;
              vm.data[i].field = f[i];
            }
          }
        }
      }
    },
    save() {
      const vm = this;
      if (vm.data.length == 0) {
        this.$message({
          type: "error",
          message: "Selecione ao menos um campo para salvar o layout",
        });
        return false;
      }

      if (vm.layout) {
        const layout = vm.list.find((x) => x.id === vm.layout);
        if (!layout) return false;
        this.$confirm(`Você deseja sobrepor o layout ${layout.name} que está selecionado?`, i18n.tc("aviso"), {
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          type: i18n.tc("aviso"),
          center: true,
        })
          .then(() => {
            const loading = vm.$loading(vm.$options.loading);
            const f = vm.data.map((x, index) => (x.ignore ? "ESPACO" + index : x.field));
            LayoutService.update(layout.id, {
              fields: f,
              type: "1",
            })
              .then((response) => {
                layout.fields = f.join(",");
                this.$message({
                  type: "success",
                  message: "Layout alterado com sucesso!",
                });
              })
              .catch((error) => {
                this.$message({
                  type: "error",
                  message: error,
                });
              })
              .finally(() => loading.close());
          })
          .catch(() => {
            vm.newLayout();
          });
      } else {
        vm.newLayout();
      }
    },
    newLayout() {
      const vm = this;
      this.$prompt("Informe um nome para o layout", "Salvar", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        inputPlaceholder: "Informe um nome",
        inputErrorMessage: "É obrigatório informar um nome",
        inputValidator: function (v) {
          if (!v) {
            return false;
          }
        },
      })
        .then(async ({ value }) => {
          const loading = vm.$loading(vm.$options.loading);
          const data = {
            name: value,
            fields: vm.data.map((x, index) => (x.ignore ? "ESPACO" + index : x.field)),
            type: "1",
          };

          await LayoutService.add(data)
            .then(async (response) => {
              vm.list.push(response);
              this.$message({
                type: "success",
                message: "Layout salvo com sucesso",
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        })
        .catch(() => {});
    },
    remove() {
      const vm = this;
      const layout = vm.list.find((x) => x.id === vm.layout);
      if (!layout) return false;

      this.$confirm(`Deseja remover o layout ${layout.name}?`, i18n.tc("aviso"), {
        confirmButtonText: "OK",
        cancelButtonText: i18n.tc("cancelar"),
        type: i18n.tc("aviso"),
        center: true,
      }).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        LayoutService.delete(layout.id)
          .then((response) => {
            vm.list.splice(
              vm.list.findIndex((x) => x.id === layout.id),
              1
            );
            this.$message({
              type: "success",
              message: "Layout removido com sucesso!",
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  data() {
    return {
      data: [],
      list: [],
      layout: "",
      customerData: null,
      availableServices: [],
      customerList: "",
      current: null,
      fields: [],
      dialog: {
        columns: false,
      },
      mandatory: ["CEP", "PESO", "SERVICO", "CPF_CNPJ"],
      options: {
        servico: "",
        DEPARTAMENTO: "",
        vd: "NÃO",
        ar: "NÃO",
        arDigital: "NÃO",
        maoPropria: "NÃO",
        artigosPerigosos: "NÃO",
      },
      tableData: [
        {
          label: "CPF_CNPJ",
          key: "CPF_CNPJ",
          description: "CPF/CNPJ DO DESTINATÁRIO",
        },
        {
          label: "IE_DESTINATARIO",
          key: "IE_DESTINATARIO",
          description: "INSCRIÇÃO ESTADUAL DO DESTINATÁRIO",
        },
        {
          label: "DESTINATARIO",
          key: "DESTINATARIO",
          description: "NOME DO DESTINATÁRIO",
        },
        {
          label: "EMPRESA",
          key: "EMPRESA",
          description: "EMPRESA RELACIONADA A ENTREGA AO DESTINATÁRIO",
        },
        {
          label: "DEPARTAMENTO",
          key: "DEPARTAMENTO",
          description: "DEPARTAMENTO RELACIONADO A PRÉ-POSTAGEM",
        },
        {
          label: "ENDERECO",
          key: "ENDERECO",
          description: "ENDEREÇO DO DESTINATÁRIO",
        },
        {
          label: "NUMERO",
          key: "NUMERO",
          description: "NÚMERO DO DESTINATÁRIO",
        },
        {
          label: "COMPLEMENTO",
          key: "COMPLEMENTO",
          description: "COMPLEMENTO DO ENDEREÇO DO DESTINATÁRIO",
        },
        {
          label: "BAIRRO",
          key: "BAIRRO",
          description: "BAIRRO DO DESTINATÁRIO",
        },
        {
          label: "CIDADE",
          key: "CIDADE",
          description: "CIDADE DO DESTINATÁRIO",
        },
        { label: "UF", key: "UF", description: "UF DO DESTINATÁRIO" },
        { label: "CEP", key: "CEP", description: "CEP DO DESTINATÁRIO" },
        {
          label: "TELEFONE_DESTINO",
          key: "TELEFONE_DESTINO",
          description: "TELEFONE DO DESTINATÁRIO",
        },
        {
          label: "EMAIL_DESTINO",
          key: "EMAIL_DESTINO",
          description: "EMAIL DO DESTINATÁRIO",
        },
        {
          label: "CPF_CNPJ_REM",
          key: "CPF_CNPJ_REM",
          description: "CPF/CNPJ DO REMETENTE",
        },
        {
          label: "NOME_REM",
          key: "NOME_REM",
          description: "NOME DO REMETENTE",
        },
        {
          label: "ENDERECO_REM",
          key: "ENDERECO_REM",
          description: "ENDERECO DO REMETENTE",
        },
        {
          label: "NUMERO_REM",
          key: "NUMERO_REM",
          description: "NÚMERO DO REMETENTE",
        },
        {
          label: "COMPLEMENTO_REM",
          key: "COMPLEMENTO_REM",
          description: "COMPLEMENTO DO REMETENTE",
        },
        {
          label: "BAIRRO_REM",
          key: "BAIRRO_REM",
          description: "BAIRRO DO REMETENTE",
        },
        {
          label: "CIDADE_REM",
          key: "CIDADE_REM",
          description: "CIDADE DO REMETENTE",
        },
        {
          label: "FILIAL",
          key: "FILIAL",
          description: "FILIAL",
        },
        { label: "UF_REM", key: "UF_REM", description: "UF DO REMETENTE" },
        { label: "CEP_REM", key: "CEP_REM", description: "CEP DO REMETENTE" },
        { label: "OBJETO", key: "OBJETO", description: "NÚMERO DA ETIQUETA" },
        { label: "ETIQUETA_PRIMARIA", key: "ETIQUETA_PRIMARIA", description: "ETIQUETA PRIMÁRIA" },
        {
          label: "EMBALAGEM",
          key: "EMBALAGEM",
          description: "EMBALAGEM UTILIZADA PARA O ENVIO AO DESTINATÁRIO",
        },
        {
          label: "TIPO",
          key: "TIPO",
          description: "TIPO DA EMBALAGEM :0-ENVELOPE E 1-PACOTE",
        },
        {
          label: "PESO",
          key: "PESO",
          description: "PESO DO OBJETO EM GRAMAS",
        },
        {
          label: "PEDIDO",
          key: "PEDIDO",
          description: "NÚMERO DO PEDIDO REFERENTE AO OBJETO",
        },
        {
          label: "ALTURA",
          key: "ALTURA",
          description: "ALTURA DO OBJETO EM CENTÍMETROS",
        },
        {
          label: "LARGURA",
          key: "LARGURA",
          description: "LARGURA DO OBJETO EM CENTÍMETROS",
        },
        {
          label: "COMPRIMENTO",
          key: "COMPRIMENTO",
          description: "COMPRIMENTO DO OBJETO EM CENTÍMETROS",
        },
        {
          label: "DIAMETRO",
          key: "DIAMETRO",
          description: "DIÂMETRO DO OBJETO EM CENTÍMETROS",
        },
        {
          label: "SERVICO",
          key: "SERVICO",
          description: "CÓDIGO OU NOME DO SERVIÇO REFERENTE A PRÉ-POSTAGEM",
        },
        {
          label: "NOTA",
          key: "NOTA",
          description: "NÚMERO DA NOTA REFERENTE AO OBJETO",
        },
        {
          label: "QTD",
          key: "QTD",
          description: "QUANTIDADE DE OBJETOS REFERENTES A NOTA",
        },
        {
          label: "VALOR_DECLARADO",
          key: "VALOR_DECLARADO",
          description: "VALOR DECLARADO REFERENTES AO OBJETO",
        },
        {
          label: "CONTRATO",
          key: "CONTRATO",
          description: "NÚMERO DO CONTRATO REFERENTE A PRÉ-POSTAGEM",
        },
        {
          label: "CARTAO",
          key: "CARTAO",
          description: "NÚMERO DO CARTÃO REFERENTE A PRÉ-POSTAGEM",
        },
        {
          label: "AC",
          key: "AC",
          description: "AOS CUIDADOS, REFERENTE A PESSOA QUE DEVERÁ RECEBER O OBJETO",
        },
        {
          label: "DCE_EMITE",
          key: "DCE_EMITE",
          description: "EMITIR A DCE PARA ESSE OBJETO",
        },
        {
          label: "ISENTO_DCE",
          key: "ISENTO_DCE",
          description: "ISENTO DE DC-E: 0 OU N PARA NÃO E 1 OU S PARA SIM",
        },
        {
          label: "MP",
          key: "MP",
          description: "MÃO PRÓPRIA: 0 OU N PARA NÃO E 1 OU S PARA SIM",
        },
        {
          label: "AR",
          key: "AR",
          description: "AVISO DE RECEBIMENTO: 0 OU N PARA NÃO E 1 OU S PARA SIM",
        },
        {
          label: "URGENTE",
          key: "URGENTE",
          description: "URGENTE: 0 OU N PARA NÃO E 1 OU S PARA SIM",
        },
        {
          label: "REGISTRADO",
          key: "REGISTRADO",
          description: "REGISTRADO: 0 OU N PARA NÃO E 1 OU S PARA SIM",
        },
        {
          label: "WHATSAPP",
          key: "WHATSAPP",
          description: "WHATSAPP: 0 OU N PARA NÃO E 1 OU S PARA SIM [VIA EMAIL/TELEFONE]",
        },
        {
          label: "AP",
          key: "AP",
          description: "ARTIGOS PERIGOSOS: 0 OU N PARA NÃO E 1 OU S PARA SIM",
        },
        {
          label: "OBSERVAÇÃO",
          key: "OBSERVACAO",
          description: "OBSERVAÇÃO SOBRE OBJETO OU PRÉ-POSTAGEM",
        },
        {
          label: "DCE_PRODUTO",
          key: "DCE_PRODUTO",
          description: "ITENS DA DECLARAÇÃO DE CONTEUDO SEPARADO POR #",
        },
        {
          label: "DCE_QTD",
          key: "DCE_QTD",
          description: "QUANTIDADE DE CADA ITEM DA DECLARAÇÃO CONTEUDO SEPARADO POR #",
        },
        {
          label: "DCE_VALOR",
          key: "DCE_VALOR",
          description: "VALORES DE CADA ITEM DA DECLARAÇÃO CONTEUDO SEPARADO POR #",
        },
        {
          label: "NUMERO_NFE",
          key: "NUMERO_NFE",
          description: "NUMERO DA NOTA FISCAL",
        },
        {
          label: "SERIE_NFE",
          key: "SERIE_NFE",
          description: "NUMERO DE SERIE DA NOTA FISCAL",
        },
        {
          label: "CHAVE_NFE",
          key: "CHAVE_NFE",
          description: "CHAVE DA NOTA FISCAL",
        },
        {
          label: "VALOR_NFE",
          key: "VALOR_NFE",
          description: "VALOR DA NOTA FISCAL",
        },
      ],
    };
  },
  watch: {
    async customerList(newVal) {
      if (!newVal) return;
      try {
        this.loading = true;
        const response = await CustomerService.get(newVal);

        // guarda os dados completos do cliente
        this.customerData = response;

        // extrai os serviços
        this.availableServices = response.service.map(s => ({
          name: s.name,
          code: s.code
        }));
        // nenhum serviço selecionado por padrão; departamento é por cliente
        this.options.servico = "";
        this.options.DEPARTAMENTO = "";

        this.$message({
          type: "success",
          message: `Serviços do cliente "${response.name}" carregados com sucesso!`,
        });
      } catch (error) {
        console.error(error);
        this.$message({
          type: "error",
          message: "Erro ao buscar dados do cliente.",
        });
      } finally {
        this.loading = false;
      }
    },
    "options.servico"(newVal) {
      // marca apenas o selecionado (v-model guarda o código do serviço)
      this.availableServices.forEach(s => { s.selected = s.code === newVal; });
    }
  },

};
</script>
<style>
.w-33 {
  width: 33%;
}

.table th,
.table td {
  padding: 2px !important;
}

.list-group-item {
  padding: 2px 2px !important;
}

.table-header-color { color: white; background-color: blue; }

.mapping-config {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fafafa;
  padding: 15px 20px 5px;
}

.mapping-config .el-col {
  margin-bottom: 10px;
}

.mapping-config .el-radio {
  margin-right: 10px;
}

.mapping-label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #606266;
}

.mapping-section {
  display: block;
  margin-top: 20px;
}

.mapping-section-title {
  display: block;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #909399;
  text-transform: uppercase;
}

.mapping-layout-actions {
  padding-top: 26px;
}

.mapping-layout-actions .el-button {
  margin-left: 0;
  margin-right: 8px;
  margin-bottom: 8px;
}

@media (max-width: 1199px) {
  .mapping-layout-actions {
    padding-top: 0;
  }
}

.mapping-additionals {
  line-height: 40px;
}

.mapping-additionals .el-checkbox {
  margin-left: 0;
  margin-right: 12px;
}

/* células das tabelas sem quebra de linha */
.mapping-nowrap .cell {
  white-space: nowrap;
}

.mapping-section .table th,
.mapping-section .table td {
  white-space: nowrap;
}

.mapping-footer {
  margin-top: 30px;
  text-align: right;
}
</style>